import Price from '~/utils/Price/Price';

export const calculateComparativePrice = (
	price: Price,
	packageSize: number,
	amountOfSubstanceInUnit: number
): Price => {
	const value = Number(price.value) / (packageSize * amountOfSubstanceInUnit);
	return new Price(String(value), price.currency);
};
